import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createLogger } from "../../helper/logger";
import { SignInButton } from "../SignInButton";

import { loginRequest } from "../../authConfig";

export function Login() {
	const { instance, inProgress } = useMsal();
	const navigate = useNavigate();
	const realIsAuthenticated = useIsAuthenticated();
	const useFakeAuth =
		process.env.REACT_APP_AUTH_FAKE_IT === "TRUE" ||
		process.env.REACT_APP_AUTH_FAKE_IT === "YES";

	// Override authentication state when in fake mode
	const isAuthenticated = useFakeAuth ? true : realIsAuthenticated;

	// Display message for development mode
	const [devModeMessage] = useState(
		useFakeAuth ? "Development mode active - using mock authentication" : "",
	);
	// Create logger instance
	const logger = useMemo(() => createLogger("Login"), []);

	useEffect(() => {
		// For fake auth, redirect immediately
		if (useFakeAuth) {
			logger.info("🔑 Using mock authentication - redirecting to app");
			navigate("/wedge/wb-home");
			return;
		}

		// Regular authentication flow
		if (isAuthenticated && inProgress === "none") {
			navigate("/wedge/wb-home");
		} else if (inProgress === "none" && !useFakeAuth) {
			instance.loginRedirect(loginRequest);
			logger.debug("Auto login redirect initiated");
		}
	}, [
		instance.loginRedirect,
		isAuthenticated,
		navigate,
		inProgress,
		logger,
		useFakeAuth,
	]);

	return (
		<div className="container container-display" style={{ flex: "1" }}>
			<div className="row justify-content-center">
				<div className="col-xl-6 col-lg-12 col-md-12">
					<div className="card o-hidden border-0 shadow-lg my-5">
						<div className="card-body p-0">
							<div className="row">
								<div className="col-lg-12">
									<div className="p-5 text-center">
										<div className="text-center">
											<img className="logo" src="/img/FRPLogo.svg" alt="logo" />
										</div>
										<div>
											This application needs you to be logged in to use it.
										</div>
										{useFakeAuth && (
											<div className="alert alert-success mt-2">
												{devModeMessage}
											</div>
										)}
										<SignInButton />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Login;
